import { MetricIdentifier } from 'modules/experiments/constants';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { ExperimentVariantBreakdownArray, MetricOption } from 'modules/experiments/types';
import { Dispatch, SetStateAction } from 'react';
import { Skeleton } from 'ui/skeleton';
import { HeaderMetricSection } from './HeaderMetricSection';
import { BreakdownHeader, BreakdownHeaderTitle } from './Styled';

type CardHeaderProps = {
  loading: boolean;
  options: MetricOption<string>[];
  rows: ExperimentVariantBreakdownArray;
  metricMap: Record<string, MetricIdentifier>;
  selectedMetricsColumn: string[];
  setSelectedMetricsColumn: Dispatch<SetStateAction<string[]>>;
};

export const CardHeader = ({
  rows,
  loading,
  options,
  metricMap,
  selectedMetricsColumn,
  setSelectedMetricsColumn,
}: CardHeaderProps) => {
  const { t } = useExperimentsTranslations();

  return (
    <BreakdownHeader>
      <BreakdownHeaderTitle>{t('cardHeading.variantBreakdown')}</BreakdownHeaderTitle>
      {loading ? (
        <Skeleton width={200} height={38} />
      ) : (
        <HeaderMetricSection
          rows={rows}
          options={options}
          metricMap={metricMap}
          selectedMetricsColumn={selectedMetricsColumn}
          setSelectedMetricsColumn={setSelectedMetricsColumn}
        />
      )}
    </BreakdownHeader>
  );
};
